import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

import {
  userReducer,
  verifyOtpReducer,
  verifyOtpArnReducer
} from "../Reducers/userReducer";
import { faqReducer } from "../Reducers/FaqReducer";
import {
  personalDetailsReducer,
  savePersonalDetailsReducer,
  saveFileUploadReducer,
  verifyEmailReducer,
} from "../Reducers/personalDetailsReducer";
import { landingPageReducer } from "../Reducers/landingReducer";
import {
  nidDetailsReducer,
  nidUploadFilesReducer,
  savenidDetailsReducer,
  deleteUploadedFileReducer,
  nidDetailsWithOCRReducer,
  verifyProfileChecksReducer,
  generateCaptchaReducer,
  sendOtpReducer,
  verifyAOtpReducer,
  savePanReducer
} from "../Reducers/nidDetailsReducer";
import { authorizationReducer, arnAuthorizationReducer } from "../Reducers/authorizationReducer";
import {
  employmentReducer,
  employmentAddReducer,
  employmentRemoveReducer,
  employmentQuestionReducer,
  saveEmploymentReducer,
  previousEmploymentCountReducer,
  employmentViaUANReducer
} from "../Reducers/employmentReducer";
import {
  docRegistrationReducer,
  saveDocRegistrationReducer,
} from "../Reducers/doctorRegistrationReducer";
import {
  educationReducer,
  educationAddReducer,
  educationRemoveReducer,
  educationUpdateCampusHireReducer,
  educationSaveReducer,
  MRLDocumentReducer
} from "../Reducers/educationReducer";
import {
  getEAadhaarReducer,
  getEAadhaarCaptchaReducer,
  getAadhaarLinkedOTPReducer,
  verifyAadhaarLinkedOTPReducer,
  saveEAadhaarReducer,
} from "../Reducers/eAadhaarReducer";
import {
  addressReducer,
  addressAddReducer,
  addressRemoveReducer,
  addressSaveReducer,
  addressUpdateQuestionReducer,
  addressValidationReducer,
  addressNewSaveReducer,
  addressAddNewReducer,
} from "../Reducers/addressReducer";
import { logoutReducer } from "../Reducers/logoutReducer";
import { carouselReducer } from "../Reducers/carouselReducer";
import { drugReducer, drugSaveReducer } from "../Reducers/drugReducer";
import { pincodeReducer } from "../Reducers/pincodeReducer";
import {
  profilePreviewReducer,
  saveProfilePreviewReducer,
} from "../Reducers/profilePreviewReducer";
import {
  otherDetailsReducer,
  saveOtherDetailsReducer,
} from "../Reducers/otherDetailsReducer";
import {
  personalReferenceReducer,
  savePersonalReferenceReducer,
} from "../Reducers/personalReferenceReducer";
import { removeFileReducer } from "../Reducers/uploadFileReducer";
import { licenseReducer, licenseSaveReducer } from "../Reducers/licenseReducer";
import {
  feedbackReducer,
  feedbackSaveReducer,
} from "../Reducers/feedbackReducer";

import {
  professionalReferenceReducer,
  profRefAddReducer,
  profRefRemoveReducer,
  profRefSaveReducer,
} from "../Reducers/professionalReferenceReducer";
import {
  scotlandReducer,
  saveScotlandReducer,
} from "../Reducers/scotlandDisclosureReducer";
import {
  businessAddressReducer,
  saveBusinessAddressReducer,
  businessValidationReducer
} from "../Reducers/businessAddressReducer";
import {
  eligibilityReducer,
  saveEligibilityReducer,
} from "../Reducers/eligibilityToWorkReducer";

import { duplicityDiscardReducer } from "../Reducers/duplicityDiscardReducer";
import { duplicityIgnoreReducer } from "../Reducers/duplicityIgnoreReducer";
import {
  pvReducer,
  pvSaveDataReducer,
  pvUpdateReducer,
} from "../Reducers/pvReducer";
import {
  creditExperianReducer,
  saveCreditExperianReducer,
  otpMatchExperianReducer,
  saveExperianReducer,
  getCityStateReducer,
  questionAnswerReducer,
} from "../Reducers/creditExperianHistoryReducer";
import { clientChangeReducer } from "../Reducers/clientListReducer";
import {
  creditCibilReducer,
  sendOtpCreditCibilReducer,
  otpMatchCibilReducer,
  saveCibilReducer,
  saveAlternateMobileReducer,
  saveSkipStepReducer,
  verifyAnswersReducer,
} from "../Reducers/creditCibilHistoryReducer";
import { bankDataReducer, saveBankDataReducer, instantBankDataReducer, uploadBankReducer } from "../Reducers/bankVerificationReducer";
import { visualDocReducer, saveVisualDocReducer, uploadVisDocReducer } from "../Reducers/visualDocReducer";
import { acceptUanReducer, fetchGapReducer, fetchUanReducer, removeSalaryReducer, saveGapReasonReducer, saveUanReducer, uanReducer, updateUanReducer, uploadSalaryReducer } from "../Reducers/uanReducer";
import {
  InsuffReducer,
  InsuffUploadFilesReducer
} from "../Reducers/InsuffReducer";
import {
  DAVReducer,
} from "../Reducers/DAVReducer";
import { uploadArnReducer } from "../Reducers/uploadArnReducer";
import {downlaodArnReducer} from "../Reducers/downloadArnReducer";
import { deleteFileReducer } from "../Reducers/deleteFileReducer";
import {saveAuthReducer} from "../Reducers/saveAuthReducer";
import {autoLoginReducer} from "../Reducers/autoLoginReducer";
import { ClientLogoutReducer } from "../Reducers/clientLogoutReducer";
import {profileFieldsReducer} from "../Reducers/profileFieldsReducer";
import { personalDetailByClientReducer } from "../Reducers/personalDetailByClientReducer";
import { landingClientReducer } from "../Reducers/landingClientReducer"; 
import { verifyCompletedReducer } from "../Reducers/personalDetailsReducer";
import { paymentReducer, paymentSaveReducer } from "../Reducers/paymentReducer";
import { onboardingDetailReducer, saveOnboardingDetailReducer } from "../Reducers/onboardingDetailsReducer";
import { digiLockerDataReducer, checkDocReducer, UploadDigiDocReducer} from "../Reducers/DigiLockerReducer";
const reducer = combineReducers({
  user: userReducer,
  authorization: authorizationReducer,
  arnAuthorization: arnAuthorizationReducer,
  faq: faqReducer,
  verifyOtp: verifyOtpReducer,
  verifyOtpArn: verifyOtpArnReducer,
  personalDetails: personalDetailsReducer,
  savedPersonalDetails: savePersonalDetailsReducer,
  savedFileDetails: saveFileUploadReducer,
  verifyEmail: verifyEmailReducer,
  verifyCompleted: verifyCompletedReducer,
  removedFileDetails: removeFileReducer,
  landingPage: landingPageReducer,
  nidDetails: nidDetailsReducer,
  uploadFilesData: nidUploadFilesReducer,
  saveNidDetailsData: savenidDetailsReducer,
  deletedFilesData: deleteUploadedFileReducer,
  education: educationReducer,
  educationAdd: educationAddReducer,
  educationRemove: educationRemoveReducer,
  employment: employmentReducer,
  questionData: employmentQuestionReducer,
  employmentSaveData: saveEmploymentReducer,
  employmentAdd: employmentAddReducer,
  employmentRemove: employmentRemoveReducer,
  bankData: bankDataReducer,
  saveBankData1: saveBankDataReducer,
  instantBankData: instantBankDataReducer,
  uploadBank: uploadBankReducer,
  visualDoc: visualDocReducer,
  uan: uanReducer,
  fetchUan: fetchUanReducer,
  acceptUan: acceptUanReducer,
  uploadSalary: uploadSalaryReducer,
  removeSalary: removeSalaryReducer,
  updateUan: updateUanReducer,
  saveUan: saveUanReducer,
  fetchGap: fetchGapReducer,
  saveGapReason: saveGapReasonReducer,
  saveVisualDoc: saveVisualDocReducer,
  uploadVisDoc: uploadVisDocReducer,
  previousEmployment: previousEmploymentCountReducer,
  onboardingDetail:onboardingDetailReducer,
  saveOnboardingData:saveOnboardingDetailReducer,

  docRegistration: docRegistrationReducer,
  docRegistrationSaveData: saveDocRegistrationReducer,

  eAadhaar: getEAadhaarReducer,
  eAadhaarCaptcha: getEAadhaarCaptchaReducer,
  eAadhaarOTP: getAadhaarLinkedOTPReducer,
  verifiedEAadhaarData: verifyAadhaarLinkedOTPReducer,
  eAadhaarSaved: saveEAadhaarReducer,

  educationUpdateCampusHire: educationUpdateCampusHireReducer,
  educationSave: educationSaveReducer,
  MRLDocument: MRLDocumentReducer,
  clientChange: clientChangeReducer,

  address: addressReducer,
  addressAdd: addressAddReducer,
  addressRemove: addressRemoveReducer,
  addressUpdateQuestion: addressUpdateQuestionReducer,
  addressSave: addressSaveReducer,
  addressValidation: addressValidationReducer,
  profilePreview: profilePreviewReducer,
  payment: paymentReducer,
  paymentSave: paymentSaveReducer,
  saveProfilePreview: saveProfilePreviewReducer,
  logout: logoutReducer,
  otherDetails: otherDetailsReducer,
  saveOtherDetails: saveOtherDetailsReducer,
  personalReference: personalReferenceReducer,
  savePersonalReference: savePersonalReferenceReducer,
  carousel: carouselReducer,
  drug: drugReducer,
  drugSave: drugSaveReducer,
  pincode: pincodeReducer,
  license: licenseReducer,
  licenseSave: licenseSaveReducer,
  feedback: feedbackReducer,
  feedbackSave: feedbackSaveReducer,
  pincode: pincodeReducer,
  profReference: professionalReferenceReducer,
  profRefAdd: profRefAddReducer,
  profRefRemove: profRefRemoveReducer,
  profRefSave: profRefSaveReducer,
  scotDisc: scotlandReducer,
  scotlandSaveData: saveScotlandReducer,
  businessAddress: businessAddressReducer,
  businessSaveData: saveBusinessAddressReducer,
  businessValidationData: businessValidationReducer,
  eligibilityWork: eligibilityReducer,
  eligibilitySaveData: saveEligibilityReducer,

  pv: pvReducer,
  pvSaveData: pvSaveDataReducer,
  pvUpdate: pvUpdateReducer,
  creditExperian: creditExperianReducer,
  saveCreditExperian: saveCreditExperianReducer,
  otpMatch: otpMatchExperianReducer,
  saveExperian: saveExperianReducer,
  creditCibil: creditCibilReducer,
  sendOtpCreditCibil: sendOtpCreditCibilReducer,
  otpMatchCibil: otpMatchCibilReducer,
  saveCibil: saveCibilReducer,
  saveAlternateMobile: saveAlternateMobileReducer,
  saveSkipStep: saveSkipStepReducer,
  verifyAnswers: verifyAnswersReducer,
  getCityState: getCityStateReducer,

  Insuff: InsuffReducer,
  InsuffFileData: InsuffUploadFilesReducer,
  autoLogin: autoLoginReducer,
  downloadArn: downlaodArnReducer,
  uploadArn: uploadArnReducer,
  deleteFile: deleteFileReducer,
  saveAuth: saveAuthReducer,
  DAV: DAVReducer,
  clientLogout: ClientLogoutReducer,
  profileFields: profileFieldsReducer,
  personalDetailByClient: personalDetailByClientReducer,
  landingClient: landingClientReducer,
  duplicityDiscard: duplicityDiscardReducer,
  duplicityIgnore: duplicityIgnoreReducer,
  nidDetailsWithOCR: nidDetailsWithOCRReducer,
  verifyProfileChecks: verifyProfileChecksReducer,
  generateCaptcha: generateCaptchaReducer,
  sendOtp: sendOtpReducer,
  verifyAOtp: verifyAOtpReducer,
  savePan: savePanReducer,
  questionAnswer: questionAnswerReducer,
  digiLockerData:digiLockerDataReducer,
  checkDocReducer:checkDocReducer,
  UploadedDigiDoc:UploadDigiDocReducer,
  addressNewSave: addressNewSaveReducer,
  addressAddNewCheck: addressAddNewReducer,
  employmentViaUAN: employmentViaUANReducer,
});

const middleware = [thunk];

const userVerificationCandidateFromStorage = localStorage.getItem("userVerificationCandidate")
  ? JSON.parse(localStorage.getItem("userVerificationCandidate"))
  : null;

  const autoLoginFromStorage = localStorage.getItem("autoLogin")
  ? JSON.parse(localStorage.getItem("autoLogin"))
  : null;

const initialState = {
  user: { userData: userVerificationCandidateFromStorage },
  autoLogin: { autoLoginData: autoLoginFromStorage },
};

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
